module.exports = {
    'Help':'ヘルプ',
    'Register':'登録',
    'Login':'ログイン',
    'Inquiry':'ご質問',
    'Consultation':'ご質問',
    'Viewing':'ご案内',
    'Application':'お申込',
    'Lease Signing':'ご契約',
    'Move In':'ご入居',
    'Find your new home':'物件を検索する',
    'Making your Japan home search easier.':'Making your Japan home search easier.',
    'Hot Properties':'人気物件',
    'Terms & Conditions':'諸条件',
    'Privacy Policy':'プライバシーポリシー',
    'Contact Us':'お問合せ',
    'For Owners':'物件所有者様へ',
    'About Us':'会社概要',
    'Rental Procedure':'賃貸の手順について',
    'JAPAN HOME FINDER - ALL RIGHTS RESERVED':'JAPAN HOME FINDER - ALL RIGHTS RESERVED',
    'ADMIN':'アドミン',
    'Account Settings':'アカウント設定',
    'Saved Properties':'保存した物件',
    'Consultation_content':'不動産の専​​門家がニーズ分析を行ったうえ、お電話などでのご相談をしながら、ご希望に沿った物件を見つけましょう。',
    'Inquiry_content':'ご検討中の物件についてお問合せください。弊社バイリンガルのスタッフより、今後のお手続きについてご連絡させていただきます。',
    'Viewing_content':'コンサルタントとのご面談後、内見ご希望の物件へご案内します。',
    "Application_content":'ご希望の物件が決まりましたら、お客様にかわりまして、お申込書の提出を致します。',
    "Lease_content":'審査が通りましたら、契約書書類の雛型を準備します。諸条件について確認し、必要に応じて交渉いたします。',
    "MoveIn_content":'物件の公共設備の設定や開設、事前入居立会を行い、必要な手続きを完了の上、鍵をお渡しいたします。ようこそ新居へ！',
    'Personalize Your Search':'検索をカスタマイズする',
    'WE assess your needs and send properties right for YOU, just for YOU':'ご希望条件に合わせた物件をお探しします！',
    'Needs Assessment':'希望条件について確認します',
    'Making It Easier':'Making It Easier',
    'Logout':'ログアウト',
    'Welcome Back':'おかえりなさい!',
    'Forgot password':'パスワードを忘れた',
    "Don't miss a thing":"Don’t miss a thing",
    'Save homes you loved and access them quickly':'お気に入りに保存し、クイックアクセスする',
    'Be up to date':'Be up to date',
    'Receive special deals and updates on your favourite properties':'お気に入り物件の最新情報を受け取る',
    'Create an Account':'アカウントを作成する',
    'Name':'名前',
    'Company':'会社',
    'Phone':'電話',
    'Email':'メール',
    'Password':'パスワード',
    'Confirm Password':'パスワードの確認',
    'By registering you accept our Terms of Services and Privacy Policy':'サービスの条件とプライバシーポリシーに同意して登録する',
    'Budget':'予算',
    'Walk to Station':'駅徒歩分',
    'Bedrooms':'間取り',
    'Property Features':'物件の特徴',
    'Search Results':'検索結果',
    'Most Recent':'最新',
    'Price (Low - High)':'価格（低－高）',
    'Price (High - Low)':'価格（高－低）',
    'Size (Low - High)':'面積（低－高）',
    'Size (High - Low)':'面積（高－低）',
    'Apply':'この条件で検索する',
    'Budget Range':'価格帯',
    'Least Number of Bedrooms':'最小間取り',
    'New':'New',
    'Hot':'人気',
    'Serviced':'家具付',
    'Pet Allowed':'ペット可能',
    'Search as I move the map':'地図上で検索',
    'Back to all properties':'物件一覧へ戻る',
    'Favorite':'お気に入り',
    'Share':'共有',
    'Inquire about this property':'この物件について問い合わせる',
    'Property Overview':'物件概要',
    'Property ID':'物件ID',
    'Property Type':'物件タイプ',
    'Rooms':'間取り',
    'Floor': '階数',
    'Construction':'構造',
    'Available Date':'入居可能日',
    'Serviced Property':'家具付き物件',
    'Size':'面積',
    'Year Built':'築年数',
    'Location':'場所',
    'Initial Costs':'初期費用',
    'Monthly Costs':'月額費用',
    'Nearby Train Stations':'最寄り駅',
    'Nearby Schools':'最寄りの学校',
    'Notes':'メモ',
    'Other properties in this building':'建物内の別物件',
    'Update account details':'アカウント情報を更新する',
    'Update Info':'情報を更新する',
    'Change Password':'パスワードの変更',
    'Current password':'現在のパスワード',
    'New password':'新パスワード',
    'Confirm new password':'新パスワードの確認',
    'Welcome back':'おかえりなさい',
    'My Account':'マイアカウント',
    'Save homes':'Save homes',
    'Please Inquire':'お問い合わせください',
    'Not Found':'見つかりません',
    'Title':'タイトル',
    'Message':'メッセージ',
    'Submit':'提出する',
    'Find your nearest office':'最寄りの事務所を探す',
    'Parking Available':'駐車場 (追加費用)',
    'Concierge' :'コンシェルジュ',
    'Security Entrance':'Security Entrance',
    'Balcony':'バルコニー',
    'Private Yard':'プライベートヤード',
    'AC/Heating':'空調設備',
    'Dishwasher':'食器洗浄機',
    'Dryer':'乾燥機',
    'Refrigerator':'冷蔵庫',
    'Print':'印刷する',
    'Need Personalized Search?':'パーソナライズド検索が必要ですか?',
    'Per Month': '/月',
    'Available Now': '入居可能',
    'Yes':'はい',
    'No': 'いいえ',
    'Area': '領域',
    'Train Lines': '電車線',
    'Train Stations': '駅',
    'No results found.':'結果が見つかりません。',
    'Please Login To Continue': '続行するにはログインしてください',
    'Incorrect email address and / or password.':'間違ったメールアドレスおよび/またはパスワード。',
    'There are no matching for your current search':'現在の検索に一致するものはありません',
    'Please broaden your search requirements':'検索要件を広げてください'
}